import dynamic from 'next/dynamic';

import classNames from 'classnames';
import { useGlobalConfig } from '../../hooks/configContext';
import { Sanity$Document } from '../../types/sanityTypes';
import BusinessUnitLink from '../BusinessUnitLink';

type NavbarProps = {
  children?: React.ReactNode;
  sanityDocument?: Sanity$Document;
  navItems?: React.ReactNode;
};

const LanguageSwitcher = dynamic(() => import('./LanguageSwitcher'), {
  ssr: false,
});

const Navbar = ({ children, sanityDocument, navItems }: NavbarProps) => {
  const { BU_CONFIG } = useGlobalConfig();

  const isMultiLocaleBusinessUnit = BU_CONFIG.isMultiLocaleBu;

  const centerLogo = !navItems;

  return (
    <nav
      // Don't change this ID - useElementHeightById relies on it
      id="otovoNavBar"
      className="z-40 flex w-full items-center bg-white px-6 shadow-sm md:px-8"
    >
      <div
        className={classNames(
          centerLogo ? 'flex-1 pt-4 pb-3 text-center' : 'shrink-0 pt-5 pb-4',
        )}
      >
        <BusinessUnitLink
          className={classNames(
            'inline-block',
            !centerLogo && 'sm:mr-4 lg:mr-9',
            centerLogo && isMultiLocaleBusinessUnit && '-mr-16',
          )}
        />
      </div>
      <div className="hidden flex-nowrap space-x-2 truncate px-1 py-1 md:flex">
        {navItems}
      </div>
      <div className="ml-auto flex items-center">
        {isMultiLocaleBusinessUnit && (
          <div>
            <LanguageSwitcher sanityDocument={sanityDocument} />
          </div>
        )}
        {children}
      </div>
    </nav>
  );
};

export default Navbar;
